import { render, staticRenderFns } from "./FourthStep.vue?vue&type=template&id=edfec1f6&scoped=true&"
import script from "./FourthStep.vue?vue&type=script&lang=ts&"
export * from "./FourthStep.vue?vue&type=script&lang=ts&"
import style0 from "./FourthStep.vue?vue&type=style&index=0&id=edfec1f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfec1f6",
  null
  
)

export default component.exports